import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { LANGUAGES, translate } from "../lib/i18n";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("pp_lang") : null;
    if (saved && LANGUAGES.find((l) => l.code === saved)) return saved;
    const nav = (typeof navigator !== "undefined" ? navigator.language || "en" : "en").slice(0, 2);
    return LANGUAGES.find((l) => l.code === nav) ? nav : "en";
  });

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.dir = meta.dir;
    document.documentElement.lang = lang;
    window.localStorage.setItem("pp_lang", lang);
  }, [lang]);

  const t = useCallback((key) => translate(lang, key), [lang]);
  const value = useMemo(() => ({ lang, setLang, t, languages: LANGUAGES }), [lang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
